<div
  class="order-request-layout__loading-overlay"
  *ngIf="
    host.notification?.type === 'create-payment-request' &&
    host.isEditMode &&
    host.isFetchingOrderData
  "
  aria-busy="true"
  aria-live="polite"
>
  <div class="loading-spinner" aria-hidden="true"></div>
  <p class="order-request-layout__loading-text">Loading order…</p>
</div>

<!--
  The "Using the shop's device" wait state now renders as an overlay above this
  modal (app-vendor-membership-device-scan-modal), so the order request stays
  visible underneath instead of being replaced.
-->
<ng-container>
  <div
    class="order-request-way-purchase-banner order-request-membership-limit-banner"
    *ngIf="host.isMembershipLimitReached() && !host.membershipStatusStrip"
    role="alert"
  >
    <p class="order-request-way-purchase-banner__text">
      {{ host.getMembershipLimitReachedMessage() }}
    </p>
  </div>

  <app-wash-history-panel
    [isLoading]="host.isLoadingOrderRequestHistoryPage"
    [banner]="host.orderRequestTodayBanner"
    [rewashEligibility]="host.orderRequestRewashEligibility"
    [membershipRewashEligibility]="host.orderRequestMembershipRewashEligibility"
    [prepaidRewashEligibility]="host.orderRequestPrepaidRewashEligibility"
    [statusStrip]="host.membershipStatusStrip"
    [historyExpanded]="host.orderRequestHistoryExpanded"
    (historyToggle)="host.toggleOrderRequestHistory()"
    (pageChange)="host.goToOrderRequestHistoryPage($event)"
    (pageSizeChange)="host.orderRequestHistoryPageSizeChange($event)"
    (rewashClick)="host.openOrderRequestRewashReasonModal($event)"
  />

  <div
    class="order-request-way-purchase-banner"
    *ngIf="host.orderRequestWayPurchaseBanner$ | async"
    role="status"
  >
    <p class="order-request-way-purchase-banner__text">Way.com purchase found.</p>
    <button
      type="button"
      class="order-request-way-purchase-banner__button btn btn-secondary btn-sm"
      (click)="host.openOrderRequestWayPurchaseDetails()"
    >
      View details
    </button>
  </div>

  <section
    class="order-request-membership-verify"
    *ngIf="host.showOrderRequestRedeemRow()"
    aria-labelledby="order-request-membership-verify-title"
  >
    <!-- CWS-1914: one line, two named groups split by a rule: membership options on the
         left, the prepaid scan on the right. -->
    <div
      class="order-request-membership-verify__group"
      *ngIf="host.showOrderRequestMembershipVerifyGroup()"
      data-cws-1266="hidden only for an expired DRB member: the banner's Refresh button replaces this group"
    >
      <h4 id="order-request-membership-verify-title" class="order-request-membership-verify__title">
        Redeem Membership
      </h4>
      <div class="order-request-membership-verify__options">
        <button
          type="button"
          class="order-request-membership-verify__option order-request-membership-verify__option--reader"
          (click)="host.onOrderRequestMembershipShopDevice()"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect
              x="3"
              y="3"
              width="12"
              height="18"
              rx="2.5"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <rect
              x="6"
              y="6"
              width="6"
              height="6"
              rx="1"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <path d="M6.5 15.5h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            <path d="M6.5 18h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            <path
              d="M17.5 8.5c1.2 1.9 1.2 5.1 0 7"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M20.5 6.5c2 3.2 2 8 0 11"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
          <span class="order-request-membership-verify__option-label">Barcode</span>
        </button>
        <button
          type="button"
          class="order-request-membership-verify__option order-request-membership-verify__option--camera"
          (click)="host.onOrderRequestMembershipScanNow()"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M3 8V5.5A1.5 1.5 0 014.5 4H7"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M21 8V5.5A1.5 1.5 0 0019.5 4H17"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M3 16v2.5A1.5 1.5 0 004.5 20H7"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M21 16v2.5A1.5 1.5 0 0119.5 20H17"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M8 9v6M11 9v6M14 9v6M16.5 9v6"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
          <span class="order-request-membership-verify__option-label">Scan by Camera</span>
        </button>
        <!-- CWS-1729: a redeemable DRB member's lookup (auto-redeem off) redeems from this row,
           not the yellow banner. Same handler and label as the banner's button. -->
        <button
          *ngIf="host.showVendorMembershipLookup && host.vendorLookupInVerifyRow"
          type="button"
          class="order-request-membership-verify__option order-request-membership-verify__option--vendor"
          data-testid="vendor-lookup-action"
          [disabled]="host.isVendorMembershipLookupRunning"
          [attr.aria-busy]="host.isVendorMembershipLookupRunning"
          (click)="host.onLookupVendorMembership()"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
            <path
              d="M9 12l2 2 4-4"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="order-request-membership-verify__option-label">
            {{ host.vendorMembershipLookupButtonLabel }}
          </span>
        </button>
      </div>
    </div>

    <div
      class="order-request-membership-verify__divider"
      *ngIf="host.showOrderRequestRedeemRowDivider"
      aria-hidden="true"
    ></div>

    <!-- CWS-1914: the customer's redemption QR names the book; the car is already in the
         booking details, so the wash is drawn against whoever drove in. -->
    <div
      class="order-request-membership-verify__group"
      *ngIf="host.showOrderRequestPrepaidRedeemScanOption()"
    >
      <h4 class="order-request-membership-verify__title">Redeem Prepaid</h4>
      <div class="order-request-membership-verify__options">
        <button
          type="button"
          class="order-request-membership-verify__option order-request-membership-verify__option--prepaid"
          data-testid="prepaid-redeem-scan-action"
          (click)="host.onOrderRequestScanPrepaidRedemptionQr()"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect
              x="3"
              y="3"
              width="7"
              height="7"
              rx="1.5"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <rect
              x="14"
              y="3"
              width="7"
              height="7"
              rx="1.5"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <rect
              x="3"
              y="14"
              width="7"
              height="7"
              rx="1.5"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <path
              d="M14 14h3v3h-3zM20 14h1M14 20h3M20 18v3"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
          <span class="order-request-membership-verify__option-label">Redeem</span>
        </button>
      </div>
    </div>
  </section>
  <p
    *ngIf="host.vendorMembershipLookupResult && host.vendorLookupInVerifyRow"
    class="order-request-membership-verify__result"
    [class.is-success]="host.vendorMembershipLookupResult.severity === 'success'"
    [class.is-error]="host.vendorMembershipLookupResult.severity === 'error'"
    role="status"
  >
    {{ host.vendorMembershipLookupResult.text }}
  </p>

  <section class="order-request-section order-request-section--booking">
    <div class="order-request-section__head">
      <h4 class="order-request-section__title">Booking Details</h4>
      <div class="order-request-head-selects">
        <div
          class="order-request-plate-location"
          *ngIf="host.shouldShowOrderRequestLocationPicker()"
        >
          <div class="location-dropdown-container">
            <div
              id="location"
              class="custom-location-dropdown"
              [class.open]="host.isLocationDropdownOpen"
              [class.disabled]="host.shouldDisableField('location')"
              [attr.tabindex]="host.shouldDisableField('location') ? -1 : 0"
              (click)="host.toggleLocationDropdown($event)"
              (focus)="host.onFieldFocus('location')"
              (blur)="host.closeLocationDropdown()"
              (keydown)="host.onLocationDropdownKeydown($event)"
              role="combobox"
              aria-haspopup="listbox"
              aria-controls="location-listbox"
              [attr.aria-expanded]="host.isLocationDropdownOpen"
              aria-label="Select location"
            >
              <div class="dropdown-selected">
                <svg
                  class="dropdown-pin"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M12 21s7-6.2 7-11.5A7 7 0 005 9.5C5 14.8 12 21 12 21z"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  />
                  <circle cx="12" cy="9.5" r="2.5" stroke="currentColor" stroke-width="1.8" />
                </svg>
                <span
                  class="selected-value"
                  [class.placeholder]="!host.formData.locationId && !host.formData.location"
                  >{{ host.getSelectedLocationName() }}</span
                >
                <svg
                  class="dropdown-arrow"
                  [class.rotated]="host.isLocationDropdownOpen"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div
                class="dropdown-menu"
                role="listbox"
                id="location-listbox"
                *ngIf="host.isLocationDropdownOpen"
                (mousedown)="$event.preventDefault()"
              >
                <div *ngIf="host.isLoadingLocationsForDropdown" class="dropdown-loading">
                  Loading locations...
                </div>
                <ng-container
                  *ngIf="
                    !host.isLoadingLocationsForDropdown &&
                    host.availableLocationsForDropdown.length > 0
                  "
                >
                  <div
                    *ngFor="let location of host.availableLocationsForDropdown; let i = index"
                    class="dropdown-option"
                    role="option"
                    [attr.aria-selected]="location.id === host.formData.locationId"
                    [class.selected]="location.id === host.formData.locationId"
                    [class.active]="i === host.locationDropdownActiveIndex"
                    (click)="host.selectLocationForNotification(location, $event)"
                  >
                    {{ location.name }}
                  </div>
                </ng-container>
                <div
                  *ngIf="
                    !host.isLoadingLocationsForDropdown &&
                    host.availableLocationsForDropdown.length === 0
                  "
                  class="dropdown-no-data"
                >
                  No locations available
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="order-request-lane-field" *ngIf="host.shouldShowOrderRequestLanePicker()">
          <div class="form-group">
            <label for="lane"
              >Lane
              <span class="required" *ngIf="host.isOrderRequestLaneSelectionRequired()"
                >*</span
              ></label
            >
            <div class="location-dropdown-container">
              <div
                id="lane"
                class="custom-location-dropdown"
                [class.open]="host.isLaneDropdownOpen"
                [class.disabled]="host.isLoadingOrderRequestLanes"
                [attr.tabindex]="host.isLoadingOrderRequestLanes ? -1 : 0"
                (click)="host.toggleLaneDropdown($event)"
                (focus)="host.onFieldFocus('lane')"
                (blur)="host.closeLaneDropdown()"
                (keydown)="host.onLaneDropdownKeydown($event)"
                role="combobox"
                aria-haspopup="listbox"
                aria-controls="lane-listbox"
                [attr.aria-expanded]="host.isLaneDropdownOpen"
                aria-label="Select lane"
              >
                <div class="dropdown-selected">
                  <span
                    class="selected-value"
                    [class.placeholder]="!host.formData.laneId && !host.formData.lane"
                    >{{
                      host.isLoadingOrderRequestLanes
                        ? 'Loading lanes...'
                        : host.getSelectedLaneName()
                    }}</span
                  >
                  <svg
                    class="dropdown-arrow"
                    [class.rotated]="host.isLaneDropdownOpen"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  class="dropdown-menu"
                  role="listbox"
                  id="lane-listbox"
                  *ngIf="host.isLaneDropdownOpen"
                  (mousedown)="$event.preventDefault()"
                >
                  <div *ngIf="host.isLoadingOrderRequestLanes" class="dropdown-loading">
                    Loading lanes...
                  </div>
                  <ng-container
                    *ngIf="
                      !host.isLoadingOrderRequestLanes && host.availableOrderRequestLanes.length > 0
                    "
                  >
                    <div
                      *ngFor="let lane of host.availableOrderRequestLanes; let i = index"
                      class="dropdown-option"
                      role="option"
                      [attr.aria-selected]="lane.id === host.formData.laneId"
                      [class.selected]="lane.id === host.formData.laneId"
                      [class.active]="i === host.laneDropdownActiveIndex"
                      (click)="host.selectLaneForNotification(lane, $event)"
                    >
                      {{ lane.name }}
                    </div>
                  </ng-container>
                  <div
                    *ngIf="
                      !host.isLoadingOrderRequestLanes &&
                      host.availableOrderRequestLanes.length === 0
                    "
                    class="dropdown-no-data"
                  >
                    No lanes available
                  </div>
                </div>
              </div>
            </div>
            <div
              class="field-error"
              *ngIf="host.isOrderRequestLaneSelectionRequired() && !host.formData.laneId?.trim()"
            >
              Lane is required.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="order-request-booking-grid"
      [class.order-request-booking-grid--with-photos]="host.showOrderRequestLprAxisPlatePreview()"
    >
      <div class="order-request-booking-fields">
        <div class="order-request-plate-state">
          <label class="order-request-plate-field-label" for="license-plate-state"
            >State <span class="required">*</span></label
          >
          <div class="select-wrapper p-custom-select order-request-plate-state-select-wrap">
            <mat-select
              id="license-plate-state"
              class="order-request-plate-state-select form-select"
              panelClass="order-request-state-select-panel"
              disableOptionCentering
              data-fs-unmask
              [(ngModel)]="host.formData.vehicleLicensePlateState"
              (ngModelChange)="host.onOrderRequestPlateStateChange($event)"
              placeholder="State"
              [disabled]="
                host.shouldDisableField('vehicleLicensePlate') || host.isApplyingLprPlateCorrection
              "
            >
              <mat-select-trigger>
                <span class="order-request-plate-state-selected">{{
                  host.getOrderRequestStateLabel(host.formData.vehicleLicensePlateState)
                }}</span>
              </mat-select-trigger>
              <app-select-search #plateStateSearch placeholder="Search states"></app-select-search>
              <mat-option
                *ngFor="
                  let state of host.usStates
                    | selectFilter: plateStateSearch.query : ['name', 'code']
                "
                [value]="state.code"
              >
                <span class="order-request-plate-state-option"
                  >{{ state.code }} - {{ state.name }}</span
                >
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="order-request-plate-number">
          <label class="order-request-plate-field-label" for="license-plate"
            >Plate number <span class="required">*</span></label
          >
          <div class="license-plate-input-with-loader">
            <input
              type="text"
              id="license-plate"
              data-fs-unmask
              [ngModel]="host.orderRequestPlateNumber"
              (input)="host.onOrderRequestPlateNumberInput($event)"
              (paste)="host.onOrderRequestPlateNumberPaste($event)"
              [disabled]="
                host.shouldDisableField('vehicleLicensePlate') || host.isApplyingLprPlateCorrection
              "
              class="form-control"
              [class.error]="host.licensePlateValidationError"
              placeholder="Enter plate number"
              required
              (focus)="host.onFieldFocus('vehicleLicensePlate')"
              (blur)="host.hideLicensePlateDropdown()"
            />
            <div
              class="lpr-plate-correction-loader"
              *ngIf="host.isApplyingLprPlateCorrection"
              aria-hidden="true"
            >
              <div class="lpr-plate-correction-spinner"></div>
            </div>
          </div>
          <div class="field-error" *ngIf="host.licensePlateValidationError">
            {{ host.licensePlateValidationError }}
          </div>
        </div>
        <div class="order-request-booking-field">
          <div class="form-group phone-input-wrapper">
            <label for="phone-number"
              >Phone number
              <span class="required" *ngIf="host.isCustomerPhoneRequired()">*</span></label
            >
            <div class="phone-input-container">
              <input
                type="tel"
                inputmode="tel"
                autocomplete="tel"
                id="phone-number"
                [(ngModel)]="host.formData.customerContact"
                [disabled]="host.isOrderRequestBookingDetailsLocked()"
                class="form-control"
                [attr.maxlength]="host.customerPhoneMaxLength"
                [class.error]="
                  host.phoneValidationError ||
                  (host.isMonthlyPackageSelected() && !host.formData.customerContact?.trim())
                "
                placeholder="Enter phone number"
                (input)="host.onFieldChange('customerContact', $event)"
                (paste)="host.onCustomerPhonePaste($event)"
                (focus)="host.onFieldFocus('customerContact')"
                (blur)="
                  host.hidePhoneDropdown(); host.onPhoneInputChange(host.formData.customerContact)
                "
              />
              <div
                class="phone-search-dropdown"
                *ngIf="host.showPhoneDropdown && host.phoneSearchResults.length > 0"
                (mousedown)="$event.preventDefault()"
              >
                <div
                  class="dropdown-item"
                  *ngFor="let customer of host.phoneSearchResults"
                  (click)="host.selectCustomerFromSearch(customer)"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      customerSearchRow;
                      context: { customer: customer, primary: 'phone' }
                    "
                  ></ng-container>
                </div>
              </div>
              <div class="phone-search-loading" *ngIf="host.isSearchingCustomers">
                <div class="loading-spinner"></div>
                <span>Searching...</span>
              </div>
            </div>
            <div class="field-error" *ngIf="host.phoneValidationError">
              {{ host.phoneValidationError }}
            </div>
            <!--
              Monthly has always shown this the moment the package is picked. A prepaid sale
              does not nag: the asterisk marks the field required, and the message appears on
              Save changes, which sets `phoneValidationError` and renders it in the block above.
            -->
            <div
              class="field-error"
              *ngIf="
                !host.phoneValidationError &&
                host.isMonthlyPackageSelected() &&
                !host.formData.customerContact?.trim()
              "
            >
              {{ host.customerPhoneRequiredMessage() }}
            </div>
          </div>
        </div>
        <div class="order-request-booking-field">
          <div class="form-group phone-input-wrapper">
            <label for="first-name">First Name</label>
            <div class="phone-input-container">
              <input
                type="text"
                id="first-name"
                [(ngModel)]="host.formData.customerFirstName"
                [disabled]="host.isOrderRequestBookingDetailsLocked()"
                class="form-control"
                placeholder="Enter first name"
                (input)="host.onFieldChange('customerFirstName', $event)"
                (focus)="host.onFieldFocus('customerFirstName')"
                (blur)="host.hideNameDropdown()"
              />
              <div
                class="phone-search-dropdown"
                *ngIf="host.showNameDropdown && host.nameSearchResults.length > 0"
                (mousedown)="$event.preventDefault()"
              >
                <div
                  class="dropdown-item"
                  *ngFor="let customer of host.nameSearchResults"
                  (click)="host.selectCustomerFromSearch(customer)"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      customerSearchRow;
                      context: { customer: customer, primary: 'phone' }
                    "
                  ></ng-container>
                </div>
              </div>
              <div class="phone-search-loading" *ngIf="host.isSearchingCustomersByName">
                <div class="loading-spinner"></div>
                <span>Searching...</span>
              </div>
            </div>
          </div>
        </div>
        <div class="order-request-booking-field">
          <div class="form-group">
            <label for="last-name">Last Name</label>
            <input
              type="text"
              id="last-name"
              [(ngModel)]="host.formData.customerLastName"
              [disabled]="host.isOrderRequestBookingDetailsLocked()"
              class="form-control"
              placeholder="Enter last name"
              (input)="host.onFieldChange('customerLastName', $event)"
              (focus)="host.onFieldFocus('customerLastName')"
            />
          </div>
        </div>
        <div class="order-request-booking-field">
          <div class="form-group phone-input-wrapper">
            <label for="customer-email">Email</label>
            <div class="phone-input-container">
              <input
                type="email"
                id="customer-email"
                [(ngModel)]="host.formData.customerEmail"
                [disabled]="host.isOrderRequestBookingDetailsLocked()"
                class="form-control"
                [class.error]="host.emailValidationError"
                placeholder="Enter email address"
                (input)="host.onFieldChange('customerEmail', $event)"
                (paste)="host.onCustomerEmailPaste($event)"
                (focus)="host.onFieldFocus('customerEmail')"
                (blur)="
                  host.hideEmailDropdown(); host.onEmailInputChange(host.formData.customerEmail)
                "
              />
              <div
                class="phone-search-dropdown"
                *ngIf="host.showEmailDropdown && host.emailSearchResults.length > 0"
                (mousedown)="$event.preventDefault()"
              >
                <div
                  class="dropdown-item"
                  *ngFor="let customer of host.emailSearchResults"
                  (click)="host.selectCustomerFromSearch(customer)"
                >
                  <ng-container
                    *ngTemplateOutlet="
                      customerSearchRow;
                      context: { customer: customer, primary: 'email' }
                    "
                  ></ng-container>
                </div>
              </div>
              <div class="phone-search-loading" *ngIf="host.isSearchingCustomersByEmail">
                <div class="loading-spinner"></div>
                <span>Searching...</span>
              </div>
            </div>
            <div class="field-error" *ngIf="host.emailValidationError">
              {{ host.emailValidationError }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="order-request-booking-photos"
        *ngIf="host.showOrderRequestLprAxisPlatePreview()"
        title="Lane camera capture"
      >
        <div class="order-request-photo" *ngIf="host.isOrderRequestPlateImageSlotShown()">
          <span class="order-request-photo__label">Plate photo</span>
          <div
            class="order-request-lpr-axis-image-frame order-request-lpr-axis-image-frame--inline"
          >
            <div
              class="order-request-lpr-axis-image-loader"
              *ngIf="host.isOrderRequestLprAxisPlateImageLoading()"
              aria-busy="true"
              aria-label="Loading license plate image"
            >
              <div class="lpr-plate-correction-spinner"></div>
            </div>
            <img
              *ngIf="host.isOrderRequestLprAxisPlateImageReady()"
              class="order-request-lpr-axis-image order-request-lpr-axis-image--inline"
              [appImagePreviewTrigger]="host.canOpenOrderRequestVehicleImagePreview()"
              (previewTrigger)="host.openOrderRequestVehicleImagePreview()"
              [src]="host.orderRequestPlateImageS3Url!"
              alt="License plate crop from lane camera"
              referrerpolicy="no-referrer"
              (load)="host.onOrderRequestLprAxisPlateImageLoad()"
              (error)="host.onOrderRequestLprAxisPlateImageError()"
            />
            <div
              class="order-request-lpr-axis-image-unavailable"
              *ngIf="host.isOrderRequestPlateImageSlotUnavailable()"
              role="status"
              aria-live="polite"
            >
              <span>Image not available</span>
            </div>
          </div>
        </div>
        <div class="order-request-photo" *ngIf="host.isOrderRequestVehicleImagePreviewVisible()">
          <span class="order-request-photo__label">Car photo</span>
          <div
            class="order-request-lpr-axis-image-frame order-request-lpr-axis-image-frame--inline"
          >
            <div
              class="order-request-lpr-axis-image-loader"
              *ngIf="host.isOrderRequestVehicleImageLoading()"
              aria-busy="true"
              aria-label="Loading vehicle image"
            >
              <div class="lpr-plate-correction-spinner"></div>
            </div>
            <img
              *ngIf="host.isOrderRequestVehicleImageReady()"
              class="order-request-lpr-axis-image order-request-lpr-axis-image--inline"
              [appImagePreviewTrigger]="true"
              (previewTrigger)="host.openOrderRequestVehicleImagePreview()"
              [src]="host.orderRequestVehicleImageS3Url!"
              alt="Vehicle capture from lane camera"
              referrerpolicy="no-referrer"
              (load)="host.onOrderRequestVehicleImageLoad()"
              (error)="host.onOrderRequestVehicleImageError()"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="order-request-section order-request-services">
    <div
      class="form-group order-request-most-used"
      *ngIf="host.showOrderRequestMostUsedServicesSection && host.mostUsedServiceItems.length > 0"
    >
      <label class="order-request-subsection-label">Most used services</label>
      <div class="order-request-most-used-grid" *ngIf="!host.isLoadingPackages">
        <div
          *ngFor="let item of host.mostUsedServiceItems"
          class="most-used-card"
          [class.most-used-card--themed]="
            (item.kind === 'package' || item.kind === 'prepaid') &&
            !!host.themeColorForMostUsedServiceItem(item)
          "
          [class.most-used-card--selected]="host.isMostUsedServiceItemSelected(item)"
          [class.most-used-card--disabled]="host.isMostUsedServiceItemPairedDisabled(item)"
          [class.most-used-card--addon]="item.kind === 'addon'"
          [class.most-used-card--prepaid]="item.kind === 'prepaid'"
          [class.most-used-card--package]="item.kind === 'package'"
          (pointerdown)="host.onMostUsedServiceItemPointerDown(item, $event)"
          (click)="host.onMostUsedServiceItemClick(item, $event)"
          role="button"
          (keydown.enter)="host.onMostUsedServiceItemClick(item, $event)"
          (keydown.space)="host.onMostUsedServiceItemClick(item, $event)"
          [attr.tabindex]="host.isMostUsedServiceItemPairedDisabled(item) ? -1 : 0"
          [attr.aria-disabled]="host.isMostUsedServiceItemPairedDisabled(item)"
        >
          <span
            *ngIf="
              (item.kind === 'package' || item.kind === 'prepaid') &&
              host.themeColorForMostUsedServiceItem(item) as mostUsedTheme
            "
            class="order-request-theme-fill"
            [class.order-request-theme-fill--light]="host.isLightTheme(mostUsedTheme)"
            [style.background]="mostUsedTheme"
            aria-hidden="true"
          ></span>
          <span class="most-used-card__type-badge">
            <ng-container *ngIf="item.kind === 'package' && item.packageRef">
              {{ item.packageRef.washType === 'monthly_membership' ? 'Monthly' : 'Single' }}
            </ng-container>
            <ng-container *ngIf="item.kind === 'prepaid'">Bundle</ng-container>
            <ng-container *ngIf="item.kind === 'addon'">Add-on</ng-container>
          </span>
          <div class="most-used-card__title-row">
            <span class="most-used-card__label" [attr.title]="item.label">{{ item.label }}</span>
            <ng-container *ngIf="item.kind === 'addon' && item.addonRef as muAddon">
              <span class="most-used-card__price" *ngIf="host.isMostUsedAddonSimpleMode(muAddon)">{{
                item.priceLabel
              }}</span>
            </ng-container>
            <span class="most-used-card__price" *ngIf="item.kind !== 'addon'">{{
              item.priceLabel
            }}</span>
          </div>
          <ng-container *ngIf="item.kind === 'addon' && item.addonRef as muAddon">
            <span
              class="most-used-card__committed"
              *ngIf="host.getMostUsedAddonCommittedSummary(muAddon) as muSum"
              >{{ muSum }}</span
            >
            <button
              *ngIf="host.isMostUsedAddonComplexMode(muAddon)"
              type="button"
              class="order-request-addon-pill order-request-addon-pill--outline most-used-card__addon-pill"
              [class.order-request-addon-pill--products]="muAddon.mode === 'choose_products'"
              (pointerdown)="$event.stopPropagation()"
              (click)="host.onOrderRequestAddonPillClick(muAddon, $event)"
            >
              Choose Products
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <app-order-request-packages-block
      [host]="host"
      radioName="package-radio"
      customPriceIdPrefix="single-wash-price-"
      [includePrepaid]="true"
    />

    <app-order-request-family-sale-block
      [locationId]="host.getCheckoutLocationId()"
      [primaryEligible]="host.isFamilyPrimaryEligible"
      [primaryPackageName]="host.selectedPackage?.package_name ?? ''"
      [primaryListPrice]="host.familyPrimaryListPrice"
      [primaryPlate]="host.orderRequestPlateNumber"
      [primaryState]="host.formData.vehicleLicensePlateState"
      [primaryCustomerName]="host.familyPrimaryCustomerName"
      [primaryPhone]="host.formData.customerContact"
      [primaryVehicleName]="host.familyPrimaryVehicleName"
      [eligiblePackages]="host.familyEligiblePackages"
      [states]="host.usStates"
      [disabled]="host.isUpdatingOrder"
      (membersChange)="host.onFamilyMembersChange($event)"
      (activeChange)="host.onFamilyActiveChange($event)"
    />

    <div
      class="form-group order-request-static-group"
      *ngIf="host.showOrderRequestPrepaidRedemptionSection()"
    >
      <label class="order-request-subsection-label">
        Prepaid redemption
        <span class="required" *ngIf="host.isOrderRequestPrepaidRedeemEntryPoint()">*</span>
        <span
          *ngIf="host.getOrderRequestPrepaidRedemptionStatusBadge() === 'active'"
          class="order-request-prepaid-active-badge"
          >Active</span
        >
        <span
          *ngIf="host.getOrderRequestPrepaidRedemptionStatusBadge() === 'expired'"
          class="order-request-prepaid-expired-badge"
          >Expired</span
        >
      </label>
      <ng-container *ngIf="!host.isPrepaidPurchaseConsumedForUi()">
        <app-order-request-prepaid-cards
          [host]="host"
          [loading]="host.isLoadingOrderRequestPrepaid || host.isLoadingPrepaidPurchaseStatus"
        />
      </ng-container>
      <app-prepaid-redemption
        class="order-request-prepaid-redemption-panel"
        [status]="host.prepaidPurchaseStatus"
        [loading]="host.isLoadingPrepaidPurchaseStatus"
        [error]="host.prepaidPurchaseStatusError"
        [redeemedSlots]="host.prepaidRedemptionSlots"
        [loadingRedemptions]="host.isLoadingPrepaidRedemptions"
        [redemptionsError]="host.prepaidRedemptionsError"
        [selectedSlotKeys]="host.orderRequestRedemptionSlotKeys"
        [recipient]="host.prepaidRedemptionRecipient"
        [plateError]="host.prepaidRedemptionPlateError"
        [phoneError]="host.prepaidRedemptionPhoneError"
        [emailError]="host.prepaidRedemptionEmailError"
        [firstNameError]="host.prepaidRedemptionFirstNameError"
        [lastNameError]="host.prepaidRedemptionLastNameError"
        [phoneSearchResults]="host.recipientPhoneSearchResults"
        [showPhoneDropdown]="host.showRecipientPhoneDropdown"
        [isSearchingPhone]="host.isSearchingRecipientByPhone"
        (selectionChange)="host.onOrderRequestRedemptionSelectionChange($event)"
        (recipientChange)="host.onPrepaidRedemptionRecipientChange($event)"
        (recipientFieldTouched)="host.onPrepaidRedemptionRecipientFieldTouched()"
        (recipientPlateInput)="host.onRecipientPlateSearchInput($event)"
        (recipientPhoneInput)="host.onRecipientPhoneSearchInput($event)"
        (recipientPhoneSearchSelect)="host.selectRecipientFromPhoneSearch($event)"
        (recipientPhoneBlur)="host.hideRecipientPhoneDropdown()"
        (retryLoad)="host.retryLoadPrepaidPurchaseStatus()"
        (redemptionTabOpened)="host.onPrepaidRedemptionTabOpened()"
        (retryLoadRedemptions)="host.retryLoadPrepaidRedemptions()"
      />
    </div>

    <p class="order-request-fleet-billing-note" *ngIf="host.getFleetBillingNoticeLabel() as fleet">
      Billed to {{ fleet }}. Packages, prepaid and discounts do not apply; add-ons only.
    </p>
    <div class="form-group order-request-static-group" *ngIf="host.showOrderRequestAddonsSection()">
      <label class="order-request-subsection-label">Add on</label>
      <div
        class="order-request-static-cards order-request-static-cards--addons"
        *ngIf="!host.isLoadingOrderRequestAddons; else addonLoading"
      >
        <ng-container
          *ngFor="
            let a of host.getOrderRequestAddonsOffered();
            trackBy: host.trackOrderRequestAddonById
          "
        >
          <div
            *ngIf="a.mode === 'multi_variant_package'"
            class="order-request-addon-card order-request-addon-card--multi-package"
            [class.order-request-addon-card--selected]="host.isOrderRequestAddonSelected(a.id)"
            [class.order-request-addon-card--disabled]="
              host.isOrderRequestAddonPairedWithDisabled(a)
            "
            (click)="host.toggleOrderRequestAddonSelection(a, $event)"
            role="checkbox"
            [attr.aria-checked]="host.isOrderRequestAddonSelected(a.id)"
            [attr.aria-disabled]="host.isOrderRequestAddonPairedWithDisabled(a)"
            [attr.tabindex]="host.isOrderRequestAddonPairedWithDisabled(a) ? -1 : 0"
            (keydown.enter)="host.toggleOrderRequestAddonSelection(a, $event)"
            (keydown.space)="host.toggleOrderRequestAddonSelection(a, $event)"
          >
            <div class="order-request-addon-card__header order-request-addon-card__header--multi">
              <div class="order-request-addon-card__title-stack">
                <span class="order-request-addon-card__title" [attr.title]="a.label">{{
                  a.label
                }}</span>
              </div>
              <button
                type="button"
                class="order-request-addon-pill order-request-addon-pill--outline"
                (click)="host.onOrderRequestAddonPillClick(a, $event)"
              >
                Choose Products
              </button>
            </div>
          </div>
          <ng-container *ngIf="a.mode === 'multi_variant_package'">
            <div
              *ngFor="
                let tile of host.getOrderRequestMultiVariantCommittedTiles(a);
                trackBy: host.trackOrderRequestCommittedAddonTileById
              "
              class="order-request-addon-card order-request-addon-card--vending-line order-request-addon-card--addon-subline"
              (click)="$event.stopPropagation()"
            >
              <div class="order-request-addon-card__vending-line-head">
                <span
                  class="order-request-addon-card__vending-line-title"
                  [attr.title]="tile.title"
                  >{{ tile.title }}</span
                >
                <span class="order-request-addon-pill order-request-addon-pill--vending-tag">{{
                  tile.parentLabel
                }}</span>
              </div>
              <span class="order-request-addon-card__vending-line-price">{{
                tile.priceLabel
              }}</span>
            </div>
          </ng-container>
          <div
            *ngIf="a.mode !== 'multi_variant_package'"
            class="order-request-addon-card"
            [class.order-request-addon-card--selected]="host.isOrderRequestAddonSelected(a.id)"
            [class.order-request-addon-card--expanded]="host.isOrderRequestAddonExpanded(a.id)"
            [class.order-request-addon-card--disabled]="
              host.isOrderRequestAddonPairedWithDisabled(a)
            "
            (click)="host.toggleOrderRequestAddonSelection(a, $event)"
            role="checkbox"
            [attr.aria-checked]="host.isOrderRequestAddonSelected(a.id)"
            [attr.aria-disabled]="host.isOrderRequestAddonPairedWithDisabled(a)"
            [attr.tabindex]="host.isOrderRequestAddonPairedWithDisabled(a) ? -1 : 0"
            (keydown.enter)="host.toggleOrderRequestAddonSelection(a, $event)"
            (keydown.space)="host.toggleOrderRequestAddonSelection(a, $event)"
          >
            <div
              class="order-request-addon-card__header"
              [class.order-request-addon-card__header--actions-below]="
                a.mode === 'custom_price' || a.mode === 'choose_products'
              "
            >
              <div class="order-request-addon-card__title-stack">
                <span class="order-request-addon-card__title" [attr.title]="a.label">{{
                  a.label
                }}</span>
              </div>
              <div class="order-request-addon-card__header-actions">
                <div
                  class="order-request-addon-card__saved-row"
                  *ngIf="
                    a.mode === 'choose_products' &&
                    host.getOrderRequestVendingCommittedQuantityFor(a.id) > 0
                  "
                >
                  <span
                    class="order-request-addon-card__price-value order-request-addon-card__committed-summary"
                    >{{ host.getOrderRequestVendingSummaryLabelFor(a.id) }}</span
                  >
                  <button
                    type="button"
                    class="order-request-addon-card__edit-btn"
                    (click)="host.onOrderRequestAddonPillClick(a, $event)"
                    [attr.aria-label]="'Edit products for ' + a.label"
                  >
                    <svg
                      class="order-request-addon-card__edit-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                      <path d="m15 5 4 4" />
                    </svg>
                  </button>
                </div>
                <div
                  class="order-request-addon-card__saved-row"
                  *ngIf="
                    a.mode === 'custom_price' &&
                    host.formatOrderRequestAddonSavedPrice(a.id) &&
                    !host.isOrderRequestAddonExpanded(a.id)
                  "
                >
                  <span class="order-request-addon-card__price-value">{{
                    host.formatOrderRequestAddonSavedPrice(a.id)
                  }}</span>
                  <button
                    type="button"
                    class="order-request-addon-card__edit-btn"
                    (click)="host.onOrderRequestAddonEditCustomPrice(a, $event)"
                    [attr.aria-label]="'Edit custom price for ' + a.label"
                  >
                    <svg
                      class="order-request-addon-card__edit-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                      <path d="m15 5 4 4" />
                    </svg>
                  </button>
                </div>
                <span
                  class="order-request-addon-card__fixed-price"
                  *ngIf="a.mode === 'fixed' && a.fixedPrice"
                >
                  {{ a.fixedPrice }}
                </span>
                <button
                  *ngIf="
                    a.mode === 'custom_price' &&
                    (host.isOrderRequestAddonExpanded(a.id) ||
                      !host.formatOrderRequestAddonSavedPrice(a.id))
                  "
                  type="button"
                  class="order-request-addon-pill order-request-addon-pill--outline"
                  (click)="host.onOrderRequestAddonPillClick(a, $event)"
                >
                  Custom Price
                </button>
                <button
                  *ngIf="
                    a.mode === 'choose_products' &&
                    host.getOrderRequestVendingCommittedQuantityFor(a.id) <= 0
                  "
                  type="button"
                  class="order-request-addon-pill order-request-addon-pill--outline order-request-addon-pill--products"
                  (click)="host.onOrderRequestAddonPillClick(a, $event)"
                >
                  Choose Products
                </button>
              </div>
            </div>
            <div
              class="order-request-addon-card__editor"
              *ngIf="a.mode === 'custom_price' && host.isOrderRequestAddonExpanded(a.id)"
              (click)="$event.stopPropagation()"
            >
              <label class="order-request-addon-card__amount-label" for="addon-price-{{ a.id }}"
                >Enter amount</label
              >
              <div class="order-request-addon-card__amount-input-wrap">
                <span class="order-request-addon-card__currency" aria-hidden="true">$</span>
                <input
                  type="number"
                  min="0"
                  max="999999.99"
                  step="0.01"
                  class="order-request-addon-card__amount-input"
                  [id]="'addon-price-' + a.id"
                  [ngModel]="host.getOrderRequestAddonCustomPriceDraft(a.id)"
                  (ngModelChange)="host.onOrderRequestAddonCustomPriceInput(a.id, $event)"
                  (input)="
                    host.onOrderRequestAddonCustomPriceInput(
                      a.id,
                      $any($event.target).value,
                      $event
                    )
                  "
                  (keydown)="host.onOrderRequestAddonCustomPriceKeydown($event)"
                  inputmode="decimal"
                  autocomplete="off"
                  placeholder="0.00"
                />
              </div>
              <div class="order-request-addon-card__editor-actions">
                <button
                  type="button"
                  class="order-request-addon-card__save-btn"
                  (click)="$event.stopPropagation(); host.saveOrderRequestAddonCustomPrice(a)"
                >
                  Save
                </button>
                <button
                  *ngIf="host.formatOrderRequestAddonSavedPrice(a.id)"
                  type="button"
                  class="order-request-addon-card__clear-price-btn"
                  (click)="
                    $event.stopPropagation(); host.removeOrderRequestAddonCustomPrice(a, $event)
                  "
                >
                  Clear price
                </button>
              </div>
            </div>
          </div>
          <ng-container *ngIf="a.mode === 'choose_products'">
            <div
              *ngFor="
                let line of host.getOrderRequestVendingSelectionLinesFor(a.id);
                trackBy: host.trackOrderRequestVendingLineById
              "
              class="order-request-addon-card order-request-addon-card--vending-line order-request-addon-card--addon-subline"
              [class.order-request-addon-card--selected]="host.isOrderRequestAddonSelected(a.id)"
              (click)="$event.stopPropagation()"
            >
              <div class="order-request-addon-card__vending-line-head">
                <span class="order-request-addon-card__vending-line-title"
                  >{{ line.name }} × {{ line.quantity }}</span
                >
                <span class="order-request-addon-pill order-request-addon-pill--vending-tag">{{
                  a.label
                }}</span>
              </div>
              <span class="order-request-addon-card__vending-line-price">{{
                line.lineTotalFormatted
              }}</span>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-template #addonLoading>
        <ng-container *ngTemplateOutlet="host.orderRequestCardsShimmer"></ng-container>
      </ng-template>
    </div>
    <div
      class="form-group order-request-static-group"
      *ngIf="host.showOrderRequestDiscountsSection()"
      [class.order-request-static-group--disabled]="host.isOrderRequestDiscountDisabled()"
    >
      <label
        class="order-request-subsection-label"
        [attr.title]="host.orderRequestDiscountCountTooltip"
        >Discounts</label
      >
      <div
        *ngIf="!host.isLoadingOrderRequestDiscounts; else host.orderRequestDiscountsLoading"
        class="order-request-static-cards order-request-static-cards--discounts"
        [attr.aria-disabled]="host.isOrderRequestDiscountDisabled()"
      >
        <ng-container *ngFor="let d of host.orderRequestVisibleDiscounts">
          <div
            *ngIf="d.mode === 'fixed'"
            class="order-request-static-card order-request-static-card--selectable"
            [class.order-request-static-card--selected]="host.isOrderRequestDiscountSelected(d.id)"
            [class.order-request-static-card--disabled]="host.isOrderRequestDiscountDisabled()"
            [class.order-request-static-card--has-renewal-info]="showDiscountRenewalInfo(d)"
            (click)="host.selectOrderRequestDiscount(d.id, $event)"
            role="radio"
            [attr.aria-checked]="host.isOrderRequestDiscountSelected(d.id)"
            [attr.aria-disabled]="host.isOrderRequestDiscountDisabled()"
            [tabindex]="host.isOrderRequestDiscountDisabled() ? -1 : 0"
            (keydown.enter)="host.selectOrderRequestDiscount(d.id, $event)"
            (keydown.space)="host.selectOrderRequestDiscount(d.id, $event)"
          >
            <span class="order-request-static-card__title" [attr.title]="d.label">{{
              d.label
            }}</span>
            <span class="order-request-static-card__sub" *ngIf="d.fixedPrice">{{
              d.fixedPrice
            }}</span>
            <span
              *ngIf="showDiscountRenewalInfo(d)"
              class="info-icon order-request-discount-renewal-info"
              [matTooltip]="discountRenewalTooltip(d)"
              matTooltipClass="order-request-discount-renewal-tooltip"
              matTooltipPosition="above"
              tabindex="0"
              role="img"
              aria-label="Renewal cycle details"
              (click)="$event.stopPropagation(); $event.preventDefault()"
              (keydown)="$event.stopPropagation()"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z"
                  fill="currentColor"
                />
                <path
                  d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z"
                  fill="currentColor"
                />
              </svg>
            </span>
          </div>
          <ng-container *ngIf="d.mode === 'custom'">
            <!-- After save: same tile pattern as Military / Senior (Figma node 124-26158). -->
            <div
              *ngIf="
                host.orderRequestCustomDiscountSaved && !host.orderRequestCustomDiscountExpanded
              "
              class="order-request-static-card order-request-static-card--custom-discount-saved order-request-static-card--selectable"
              [class.order-request-static-card--selected]="
                host.isOrderRequestDiscountSelected(d.id)
              "
              [class.order-request-static-card--disabled]="host.isOrderRequestDiscountDisabled()"
              (click)="host.selectOrderRequestDiscount(d.id, $event)"
              role="radio"
              [attr.aria-checked]="host.isOrderRequestDiscountSelected(d.id)"
              [attr.aria-disabled]="host.isOrderRequestDiscountDisabled()"
              [tabindex]="host.isOrderRequestDiscountDisabled() ? -1 : 0"
              (keydown.enter)="host.selectOrderRequestDiscount(d.id, $event)"
              (keydown.space)="host.selectOrderRequestDiscount(d.id, $event)"
            >
              <div class="order-request-static-card--custom-discount-saved__inner">
                <div class="order-request-static-card--custom-discount-saved__text">
                  <span
                    class="order-request-static-card__title"
                    [attr.title]="host.orderRequestCustomDiscountSaved.name"
                    >{{ host.orderRequestCustomDiscountSaved.name }}</span
                  >
                  <span class="order-request-static-card__sub">{{
                    host.orderRequestCustomDiscountSaved.valueLabel
                  }}</span>
                </div>
                <button
                  type="button"
                  class="order-request-addon-card__edit-btn"
                  (click)="host.onOrderRequestCustomDiscountEditClick($event)"
                  [disabled]="host.isOrderRequestDiscountDisabled()"
                  aria-label="Edit custom discount"
                >
                  <svg
                    class="order-request-addon-card__edit-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                    <path d="m15 5 4 4" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Collapsed “add” row or expanded editor -->
            <div
              *ngIf="
                !host.orderRequestCustomDiscountSaved || host.orderRequestCustomDiscountExpanded
              "
              class="order-request-discount-card"
              [class.order-request-discount-card--selected]="
                host.isOrderRequestDiscountSelected(d.id)
              "
              [class.order-request-discount-card--expanded]="
                host.orderRequestCustomDiscountExpanded
              "
              [class.order-request-discount-card--disabled]="host.isOrderRequestDiscountDisabled()"
              (click)="host.selectOrderRequestDiscount(d.id, $event)"
              role="radio"
              [attr.aria-checked]="host.isOrderRequestDiscountSelected(d.id)"
              [attr.aria-disabled]="host.isOrderRequestDiscountDisabled()"
              [tabindex]="host.isOrderRequestDiscountDisabled() ? -1 : 0"
              (keydown.enter)="host.selectOrderRequestDiscount(d.id, $event)"
              (keydown.space)="host.selectOrderRequestDiscount(d.id, $event)"
            >
              <div class="order-request-discount-card__head">
                <button
                  type="button"
                  class="order-request-discount-card__header-btn"
                  (click)="host.toggleOrderRequestCustomDiscount($event)"
                  [attr.aria-expanded]="host.orderRequestCustomDiscountExpanded"
                  [disabled]="host.isOrderRequestDiscountDisabled()"
                >
                  <span class="order-request-discount-card__title" [attr.title]="d.label">{{
                    d.label
                  }}</span>
                  <svg
                    class="order-request-discount-card__chevron-svg"
                    [class.order-request-discount-card__chevron-svg--open]="
                      host.orderRequestCustomDiscountExpanded
                    "
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      stroke-width="2.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <span
                  *ngIf="
                    !host.orderRequestCustomDiscountExpanded &&
                    !host.orderRequestCustomDiscountSaved
                  "
                  class="order-request-discount-card__collapsed-sub"
                  aria-hidden="true"
                >
                  &nbsp;
                </span>
              </div>
              <div
                class="order-request-discount-card__body"
                *ngIf="host.orderRequestCustomDiscountExpanded"
                (click)="$event.stopPropagation()"
              >
                <div class="order-request-discount-card__field">
                  <label
                    class="order-request-discount-card__label"
                    for="order-request-discount-name"
                    >Discount name</label
                  >
                  <input
                    id="order-request-discount-name"
                    type="text"
                    class="form-control order-request-discount-card__control"
                    [(ngModel)]="host.orderRequestCustomDiscountName"
                    [disabled]="host.isOrderRequestDiscountDisabled()"
                    autocomplete="off"
                    placeholder="e.g. Loyalty reward"
                  />
                </div>
                <div class="order-request-discount-card__field">
                  <label
                    class="order-request-discount-card__label"
                    for="order-request-discount-value"
                    >Discount value</label
                  >
                  <div
                    class="order-request-addon-card__amount-input-wrap order-request-discount-card__value-wrap"
                  >
                    <span
                      class="order-request-addon-card__currency"
                      *ngIf="host.orderRequestCustomDiscountType === 'fixed_amount'"
                      aria-hidden="true"
                      >$</span
                    >
                    <input
                      id="order-request-discount-value"
                      type="text"
                      class="order-request-addon-card__amount-input"
                      [ngModel]="host.orderRequestCustomDiscountValueDraft"
                      (ngModelChange)="host.onOrderRequestCustomDiscountValueInput($event)"
                      [disabled]="host.isOrderRequestDiscountDisabled()"
                      inputmode="decimal"
                      autocomplete="off"
                      [placeholder]="
                        host.orderRequestCustomDiscountType === 'fixed_amount' ? '0.00' : '0'
                      "
                    />
                    <span
                      class="order-request-discount-card__percent-suffix"
                      *ngIf="host.orderRequestCustomDiscountType === 'percentage'"
                      aria-hidden="true"
                      >%</span
                    >
                  </div>
                </div>
                <div class="order-request-discount-card__field">
                  <div
                    class="order-request-discount-card__label"
                    id="order-request-discount-type-label"
                  >
                    Discount type
                  </div>
                  <div
                    class="order-request-discount-card__type-radios"
                    role="radiogroup"
                    aria-labelledby="order-request-discount-type-label"
                  >
                    <label
                      class="order-request-discount-card__type-option"
                      [class.order-request-discount-card__type-option--selected]="
                        host.orderRequestCustomDiscountType === 'fixed_amount'
                      "
                    >
                      <input
                        type="radio"
                        name="order-request-discount-type"
                        class="order-request-discount-card__type-native"
                        value="fixed_amount"
                        [checked]="host.orderRequestCustomDiscountType === 'fixed_amount'"
                        [disabled]="host.isOrderRequestDiscountDisabled()"
                        (change)="host.onOrderRequestCustomDiscountTypeChange('fixed_amount')"
                      />
                      <span class="order-request-discount-card__type-label-text">Flat</span>
                    </label>
                    <label
                      class="order-request-discount-card__type-option"
                      [class.order-request-discount-card__type-option--selected]="
                        host.orderRequestCustomDiscountType === 'percentage'
                      "
                    >
                      <input
                        type="radio"
                        name="order-request-discount-type"
                        class="order-request-discount-card__type-native"
                        value="percentage"
                        [checked]="host.orderRequestCustomDiscountType === 'percentage'"
                        [disabled]="host.isOrderRequestDiscountDisabled()"
                        (change)="host.onOrderRequestCustomDiscountTypeChange('percentage')"
                      />
                      <span class="order-request-discount-card__type-label-text">Percentage</span>
                    </label>
                  </div>
                </div>
                <div
                  class="order-request-discount-card__field"
                  *ngIf="host.isOrderRequestCustomDiscountReasonRequired()"
                >
                  <label
                    class="order-request-discount-card__label"
                    id="order-request-discount-reason-label"
                    for="order-request-discount-reason"
                  >
                    Reason <span class="required">*</span>
                  </label>
                  <div
                    class="select-wrapper p-custom-select order-request-discount-reason-select-wrap"
                    [class.order-request-discount-reason-select-wrap--error]="
                      !!host.orderRequestCustomDiscountReasonError
                    "
                  >
                    <mat-select
                      id="order-request-discount-reason"
                      class="order-request-discount-reason-select form-select"
                      panelClass="order-request-discount-reason-select-panel"
                      disableOptionCentering
                      [(ngModel)]="host.orderRequestCustomDiscountReason"
                      (ngModelChange)="host.onOrderRequestCustomDiscountReasonChange($event)"
                      placeholder="Select reason"
                      [disabled]="host.isOrderRequestDiscountDisabled()"
                      aria-labelledby="order-request-discount-reason-label"
                    >
                      <mat-select-trigger>
                        <span class="order-request-discount-reason-selected">{{
                          host.getOrderRequestCustomDiscountReasonLabel(
                            host.orderRequestCustomDiscountReason
                          )
                        }}</span>
                      </mat-select-trigger>
                      <mat-option
                        *ngFor="let option of host.orderRequestCustomDiscountReasonOptions"
                        [value]="option.value"
                      >
                        <span class="order-request-discount-reason-option">{{ option.label }}</span>
                      </mat-option>
                    </mat-select>
                  </div>
                  <div
                    class="field-error"
                    *ngIf="host.orderRequestCustomDiscountReasonError"
                    role="alert"
                  >
                    {{ host.orderRequestCustomDiscountReasonError }}
                  </div>
                </div>
                <button
                  type="button"
                  class="order-request-addon-card__save-btn"
                  [disabled]="host.isOrderRequestDiscountDisabled()"
                  (click)="host.saveOrderRequestCustomDiscount($event)"
                >
                  Save
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-template #host.orderRequestDiscountsLoading>
        <ng-container *ngTemplateOutlet="host.orderRequestCardsShimmer"></ng-container>
      </ng-template>
    </div>
  </section>

  <ng-template #host.orderRequestCardsShimmer>
    <div
      class="order-request-cards-shimmer order-request-static-cards"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
    >
      <div
        *ngFor="let _ of host.orderRequestSectionShimmerSlots"
        class="order-request-cards-shimmer__card"
        aria-hidden="true"
      >
        <div
          class="order-request-cards-shimmer__line order-request-cards-shimmer__line--title"
        ></div>
        <div class="order-request-cards-shimmer__line order-request-cards-shimmer__line--sub"></div>
      </div>
    </div>
  </ng-template>
</ng-container>

<!--
  Customer-search row, shared by the name / email / phone dropdowns.

  Exactly two lines by design. Vendor members (DRB / EverWash) import as one customer row
  per membership, so a search returns several rows with identical name and phone — the
  vehicle on line two is what tells them apart (CWS-920). Kept to two lines so a list of
  those duplicates stays scannable rather than turning into a wall.

  `primary` picks which contact field leads: the email dropdown leads with the email it
  matched, the others with the phone.
-->
<ng-template #customerSearchRow let-customer="customer" let-primary="primary">
  <div class="customer-info">
    <div class="customer-row-top">
      <span class="customer-name">{{ customer.first_name }} {{ customer.last_name || '' }}</span>
      <span class="customer-prepaid-badge" *ngIf="host.customerHasPrepaidPurchase(customer)"
        >Prepaid</span
      >
    </div>
    <div class="customer-row-meta">
      <span class="customer-meta-item" *ngIf="primary === 'email' && customer.email">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect
            x="3"
            y="5.5"
            width="18"
            height="13"
            rx="2"
            stroke="currentColor"
            stroke-width="1.6"
          />
          <path
            d="M3.7 7.2l8.3 5.9 8.3-5.9"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="customer-meta-truncate">{{ customer.email }}</span>
      </span>
      <span class="customer-meta-item" *ngIf="primary !== 'email' && customer.contact">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M6.6 3h2.2l1.4 3.4-1.7 1.2a11 11 0 005.9 5.9l1.2-1.7L19 13.2v2.2a2 2 0 01-2.2 2A14 14 0 014.6 5.2 2 2 0 016.6 3z"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>{{ customer.contact }}</span>
      </span>
      <ng-container
        *ngIf="
          host.customerSearchPlate(customer) || host.customerSearchVehicle(customer);
          else noVehicleOnFile
        "
      >
        <span class="customer-meta-item customer-meta-vehicle">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M4 16v-3.2l1.7-4A2 2 0 017.6 7.5h8.8a2 2 0 011.9 1.3l1.7 4V16"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M4 13.4h16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            <circle cx="7.6" cy="16.4" r="1.4" stroke="currentColor" stroke-width="1.6" />
            <circle cx="16.4" cy="16.4" r="1.4" stroke="currentColor" stroke-width="1.6" />
          </svg>
          <span class="customer-plate-badge" *ngIf="host.customerSearchPlate(customer) as plate">{{
            plate
          }}</span>
          <span
            class="customer-vehicle-desc customer-meta-truncate"
            *ngIf="host.customerSearchVehicle(customer) as vehicleDesc"
            >{{ vehicleDesc }}</span
          >
        </span>
      </ng-container>
      <!-- Said explicitly rather than left blank: a large share of vendor rows arrive with
           no plate at all, and a gap reads as "still loading". -->
      <ng-template #noVehicleOnFile>
        <span class="customer-meta-item customer-plate-missing">No vehicle on file</span>
      </ng-template>
    </div>
  </div>
</ng-template>
